import type { OrbitSlice } from './orbitTypes'

export type OrbitActionBridge = (
  sliceId: string,
  label: string,
  id?: string,
  title?: string,
  phase6?: boolean,
) => void | Promise<void>

export const datasetId = (node?: HTMLElement | null, ...keys: string[]) =>
  keys.map((key) => node?.dataset?.[key]).find(Boolean)

export const datasetTitle = (node?: HTMLElement | null) => node?.dataset?.orbitTitle

export type SliceOptions = {
  disabled?: boolean
  disabledReason?: string
}

export const targetlessSlice = (
  id: string,
  label: string,
  icon: OrbitSlice['icon'],
  action: OrbitActionBridge,
  phase6 = false,
  options?: SliceOptions,
): OrbitSlice => ({
  id,
  label,
  icon,
  disabled: options?.disabled,
  disabledReason: options?.disabledReason,
  onFire: () => action(id, label, undefined, undefined, phase6),
})

export const slice = (
  id: string,
  label: string,
  icon: OrbitSlice['icon'],
  action: OrbitActionBridge,
  node?: HTMLElement | null,
  idOf?: (node: HTMLElement) => string | undefined,
  phase6 = false,
  data?: { id?: string; title?: string },
  options?: SliceOptions,
): OrbitSlice => ({
  id,
  label,
  icon,
  disabled: options?.disabled,
  disabledReason: options?.disabledReason,
  onFire: () => {
    const targetId = data?.id ?? (node && idOf ? idOf(node) : datasetId(node))
    const targetTitle = data?.title ?? datasetTitle(node)
    return action(id, label, targetId, targetTitle, phase6)
  },
})
